import { Injectable } from '@angular/core';
import { RedirectCommand, Resolve } from '@angular/router';
import { Config } from '@vsolv/packages/portal-config/domain';

@Injectable()
export class ConfigResolver implements Resolve<Config.PortalConfig | undefined | RedirectCommand> {
  config?: Config.PortalConfig;

  resolve() {
    return this.config;
  }
}
